
/// <summary>
/// 简化的行驶信息，不一定存在 oyyh,20161008添加注释
/// </summary>
export class DriveSimpleItem {

	constructor() {
		this.id = null;
		this.lastStreetName = null;
		this.linkStreetName = null;
		this.segmentNumber = null;
		this.signage = null;
		this.streetDistance = 0;
		this.streetLatLon = null;
		this.streetNames = null;
		this.strguide = null;
		this.tollStatus = null;
		this.turnlatlon = null;
		this.uid = null;

		this.crsCode="EPSG:4326";
	}

	
	static GetDriveSimpleItem(objProxy) {
		let simpleItem=null;
		if(objProxy==null)return simpleItem;
		simpleItem=new DriveSimpleItem();
		simpleItem.lastStreetName=objProxy.lastStreetName;
		simpleItem.linkStreetName=objProxy.linkStreetName;
		simpleItem.segmentNumber=objProxy.segmentNumber;
		simpleItem.signage=objProxy.signage;
		simpleItem.streetDistance=objProxy.streetDistance;
		simpleItem.streetLatLon=objProxy.streetLatLon;
		simpleItem.streetNames=objProxy.streetNames;
		simpleItem.strguide=objProxy.strguide;
		simpleItem.tollStatus=objProxy.tollStatus;
		simpleItem.turnlatlon=objProxy.turnlatlon;
		simpleItem.uid=objProxy.uid;
		return simpleItem;
	}

}//end DriveSimpleItem

